export interface SocialAccount {
  /** Format: int32 */
  id?: number
  /** @example elenakamperii */
  name?: string
  /**
   * Format: date
   * @example 2022-10-05
   */
  viewDate: string
  account: string
  /** Instagram name of tiktoker */
  instagramHandle: string | null
  /** Format: int64 */
  views: number
  /** Format: int64 */
  viewsGrowth: number
  /** Format: int64 */
  followers: number
  /** Format: int64 */
  followersGrowth: number
  /** Format: int64 */
  sharesGrowth: number
  /** Format: int64 */
  likesGrowth: number
  /** Format: int64 */
  commentsGrowth: number
  /** @description The presigned avatar url */
  avatarUrl?: string | null
  /** Format: int64 */
  totalUploads: number
}

export enum SocialAccountStatus {
  /** Account is reachable and public*/
  Active = 'Active',
  /** TikTok account is either banned, has been deleted or is private */
  Disabled = 'Disabled',
  /** TikTok account isnt attached to a creator */
  VerificationDenied = 'VerificationDenied',
}

export interface SocialUpdateResponse {
  id: number
  name: string
  follower: number
  disabled: boolean
  deniedApproval: boolean
  lastApproved: string | null
  /** Link to instagram account */
  instagramHandle: string | null
  avatarUrl: string | null
  status: SocialAccountStatus
}

export interface SocialVideoDownloadResponse {
  url: string
}

/** List of all tiktok usernames with their profile links */
export type SocialAccountLink = {
  [username: string]: string
}[]

export interface PerformanceStateInfo {
  state: SocialAccountPerformanceState
  shortPeriodAverage?: number
  longPeriodAverage?: number
}

export enum SocialAccountPerformanceState {
  NA = 'NA',
  BELOW_AVERAGE = 'BELOW_AVERAGE',
  NORMAL_AVERAGE = 'NORMAL_AVERAGE',
  ABOVE_AVERAGE = 'ABOVE_AVERAGE',
}

export interface SocialAccountResponse {
  /** Tiktok account informations */
  views: SocialAccount[]
  links: SocialAccountLink[]
  totalUploads?: number
  'performance-states': Record<string, PerformanceStateInfo>
}

export interface SocialVideo {
  id: string
  title: string
  /** @example yourgolfingelaine */
  accountName: string
  adult: boolean
  /** Views of the video Format: int64 */
  growth: number
  /** Shares of the video Format: int64 */
  sharesGrowth: number
  /** Likes of the video Format: int64 */
  likesGrowth: number
  /** Comments of the video Format: int64 */
  commentsGrowth: number
  /** @description The presigned url to the TikTok cover. */
  coverUrl: string
  /** @example https://tiktok.com/@yourgolfingelaine/video/7149663892682050859 */
  link: string
  canDownload: boolean
  videoTag: string | null
}

export interface SocialAccountVideosResponse {
  /** Tiktok uploaded videos from account  */
  views: SocialVideo[]
  /** Total entries that can be fetched */
  total: number
}

export enum ListScrollDirection {
  forward = 'forward',
  backward = 'backward',
}

export enum SocialMediaType {
  TikTok = 'TikTok',
  Instagram = 'Instagram',
}

export interface SocialMessage {
  socialDisplayName: string
  noSocialAccountsMessage: string
  accountLink: string
}

export const socialMessages: Record<SocialMediaType, SocialMessage> = {
  [SocialMediaType.TikTok]: {
    socialDisplayName: 'TikTok',
    noSocialAccountsMessage:
      'Add a TikTok account to easily monitor & track your analytics.',
    accountLink: 'https://www.tiktok.com/@',
  },
  [SocialMediaType.Instagram]: {
    socialDisplayName: 'Instagram Reels',
    noSocialAccountsMessage:
      'Add an Instagram account to easily monitor & track your analytics.',
    accountLink: 'https://www.instagram.com/',
  },
}
